module.exports = __webpack_public_path__ + "img/down.e6cfe2ae.svg";